import { render, staticRenderFns } from "./JSelectJiaoxueKecheng.vue?vue&type=template&id=246abdf5&scoped=true"
import script from "./JSelectJiaoxueKecheng.vue?vue&type=script&lang=js"
export * from "./JSelectJiaoxueKecheng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246abdf5",
  null
  
)

export default component.exports